export default __webpack_public_path__ + "5d9b22184e0555d823725ccaed0c1df7.png";